module.exports = __webpack_public_path__ + "img/info.5cd2c892.svg";